module.exports = __webpack_public_path__ + "img/box-container.44077726.png";